import { Component, input, InputSignal, output } from '@angular/core';
import { ButtonComponent } from '../../atoms/button/button.component';
import { DayjsFormatPipe } from '../../../pipes/date.pipe';
import { Weight } from '../../pages/user/weight/weight.types';

@Component({
  selector: 'app-weight-item',
  templateUrl: './weight-item.component.html',
  imports: [ButtonComponent, DayjsFormatPipe],
})
export class WeightItemComponent {
  public readonly weightItem: InputSignal<Weight> = input.required();

  readonly clicked = output<void>();
}
